// src/services/backoffice/authService.ts
// גרסה עם טיפול בToken Expiry
// ✅ הimports צריכים להיות בראש הקובץ
import { API_BASE_URL } from '../../config/api';

// ✅ אחרי זה שאר הקוד
export interface LoginCredentials {
  email: string;
  password: string;
}

// ... שאר הקוד
export interface LoginRequest {
  email: string;
  password: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  last_login?: string;
}

export interface LoginResponse {
  res: string;
  msg: string;
  data: {
    session_token: string;
    expires_at: string;
    user_info: User;
  };
  error_code?: string;
}



// ✅ פונקציה חדשה לטיפול בשגיאות session
export const handleSessionError = (result: any): boolean => {
  // console.log('🔐 [DEBUG] Checking for session error:', result);

  // בדיקה אם זה שגיאת session expired
  if (result.res === 'NOK' &&
    (result.error_code === 'SESSION_EXPIRED' ||
      result.msg === 'Invalid or expired session' ||
      result.msg?.includes('session'))) {

    // console.log('🔐 [DEBUG] Session expired detected! Cleaning up and redirecting...');

    // ניקוי localStorage
    localStorage.removeItem('backoffice_session_id');

    // הפניה לעמוד login
    window.location.href = '/backoffice/login';

    return true; // מסמן שטיפלנו בשגיאה
  }

  return false; // לא היתה שגיאת session
};

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    // console.log('🔐 [DEBUG] Starting login process...');
    // console.log('🔐 [DEBUG] Credentials:', { email: credentials.email, password: '***' });

    const url = `${API_BASE_URL}/Api/service/backoffice/login`;
    // console.log('🔐 [DEBUG] Request URL:', url);

    try {
      // console.log('🔐 [DEBUG] About to send fetch request...');

      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        console.error('🔐 [DEBUG] Request timeout after 30 seconds');
        controller.abort();
      }, 30000);

      const formData = new FormData();
      formData.append('email', credentials.email);
      formData.append('password', credentials.password);

      // console.log('🔐 [DEBUG] Sending as FormData...');

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        signal: controller.signal,
      });

      clearTimeout(timeoutId);
      // console.log('🔐 [DEBUG] Fetch completed!');
      // console.log('🔐 [DEBUG] HTTP Response status:', response.status);
      // console.log('🔐 [DEBUG] HTTP Response ok:', response.ok);

      if (!response.ok) {
        console.error('🔐 [DEBUG] HTTP Error - Status:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // console.log('🔐 [DEBUG] About to parse JSON...');
      const result: LoginResponse = await response.json();
      // console.log('🔐 [DEBUG] JSON parsed successfully');
      // console.log('🔐 [DEBUG] Full server response:', result);

      if (result.res === 'OK') {
        // console.log('🔐 [DEBUG] Login successful!');
        // console.log('🔐 [DEBUG] Session token:', result.data.session_token);
        // console.log('🔐 [DEBUG] User info:', result.data.user_info);

        localStorage.setItem('backoffice_session_id', result.data.session_token);
        // console.log('🔐 [DEBUG] Token saved to localStorage');

        return result;
      } else {
        console.error('🔐 [DEBUG] Login failed:', result.msg);
        throw new Error(result.msg || 'Login failed');
      }
    } catch (error) {
      console.error('🔐 [DEBUG] Login error occurred!');
      console.error('🔐 [DEBUG] Error type:', typeof error);

      if (error instanceof Error) {
        console.error('🔐 [DEBUG] Error message:', error.message);
      }

      throw error;
    }
  },

  // ✅ עודכן עם טיפול בtoken expiry
  verifySession: async (): Promise<boolean> => {
    // console.log('🔐 [DEBUG] Verifying session...');

    const token = localStorage.getItem('backoffice_session_id');
    // console.log('🔐 [DEBUG] Token from localStorage:', token ? 'EXISTS' : 'NOT_FOUND');

    if (!token) {
      // console.log('🔐 [DEBUG] No token found, session invalid');
      return false;
    }

    // TODO: כאן נוכל להוסיף בדיקה אמיתית מול השרת בעתיד
    // לעת עתה נחזיר true אם יש token
    // console.log('🔐 [DEBUG] Token exists, assuming valid (temporary)');
    return true;
  },

  logout: (): void => {
    // console.log('🔐 [DEBUG] Logging out...');
    localStorage.removeItem('backoffice_session_id');
    // console.log('🔐 [DEBUG] Token removed from localStorage');
  },

  getCurrentUser: (): User | null => {
    // console.log('🔐 [DEBUG] Getting current user...');

    const token = localStorage.getItem('backoffice_session_id');
    // console.log('🔐 [DEBUG] Token exists:', !!token);

    if (!token) {
      // console.log('🔐 [DEBUG] No token, no current user');
      return null;
    }

    // console.log('🔐 [DEBUG] Token exists, but user details need to be fetched');
    return null;
  }
};